/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActionTypes } from './action';
import { IUnitServiceRes } from "./types";


const initialState: IUnitServiceRes = {
  items: [],
  totalCount: 0,
  optionList: []
};

const productUnitServiceReducers = (state: IUnitServiceRes = initialState, action): IUnitServiceRes => {
  switch (action?.type) {
    case ActionTypes.UNIT_SERVICE_LIST: {
      const optionList = action?.payload?.items?.map((item: any, index: any) => {
        return {
          value: item.id,
          label: item.name,
          status: item.active

        }
      })
      return {
        ...state,
        ...action?.payload,
        optionList: optionList
      };
    }
    case ActionTypes.ADD_UNIT_SERVICE: {
      const items = [];
      items.push(action?.payload);
      state?.items?.map((item, index) => {
        items.push(item);
      })
      const totalCount = state?.totalCount + 1;
      return {
        ...state,
        items: items,
        totalCount: totalCount,
      };
    }
    case ActionTypes.UPDATE_UNIT_SERVICE: {
      const updatedList = state?.items.map(item =>
        item.id === action?.payload.id ? action?.payload : item
      );
      return {
        ...state,
        items: updatedList,
      };
    }
    case ActionTypes.DELETE_UNIT_SERVICE: {
      const updatedList = state.items.filter(item => item.id !== action.payload.id);
      const totalCount = state?.totalCount - 1;
      return {
        ...state,
        items: updatedList,
        totalCount: totalCount
      };
    }
    case ActionTypes.ADMIN_LOGOUT: {
      return initialState
    }
    default:
      return state;
  }
};

export default productUnitServiceReducers;
